import { Routes } from '@angular/router';

import contactsRouteData from './components/contacts/route-data';
import privacyPolicyRouteData from './components/privacy-policy/route-data';

export default <Routes>[
  {
    path: '',
    loadComponent: async () => import('./components/page-layout/page-layout.component'),
    children: [
      {
        path: 'privacy-policy',
        loadComponent: async () => import('./components/privacy-policy/privacy-policy.component'),
        data: privacyPolicyRouteData
      },
      {
        path: 'user-agreement',
        loadComponent: async () =>
          import('./components/user-agreement/user-agreement.component').then((mod) => mod.UserAgreementComponent)
      },
      {
        path: 'contacts',
        loadComponent: async () => import('./components/contacts/contacts.component'),
        data: contactsRouteData
      }
    ]
  }
];
